import { render, staticRenderFns } from "./MemberRegistration.vue?vue&type=template&id=738c6f2e"
import script from "./MemberRegistration.vue?vue&type=script&lang=ts"
export * from "./MemberRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports